const RubFormatter = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' });

export const formatPrice = (price: number) => {
  return RubFormatter.format(price);
};
